module.exports = __webpack_public_path__ + "img/english.a21497fa.png";